import { centeredMainGridClasses } from '@/styles/grid';
import { motion } from 'framer-motion';

const CardCollectionLoading = () => {
  return (
    <div className={`${centeredMainGridClasses} !col-start-1 mb-40`}>
      <div className="col-span-full mb-32">
        <motion.div
          className="h-40 w-1/3 rounded-2 bg-black-100 opacity-10 md:h-56"
          initial={{ opacity: 0.1 }}
          animate={{ opacity: [0.1, 0.3, 0.1] }}
          transition={{ duration: 3, repeat: Infinity }}
        ></motion.div>
      </div>
      <div className="col-span-full h-[464px] rounded-28 bg-white-100 p-32 md:col-span-6 lg:col-span-4">
        <motion.div
          className="m-auto mt-24 h-16 w-64 rounded-28 bg-black-100 opacity-10"
          initial={{ opacity: 0.1 }}
          animate={{ opacity: [0.1, 0.3, 0.1] }}
          transition={{ duration: 3, repeat: Infinity }}
        ></motion.div>
        <div className="mt-64 h-32 w-full rounded-28 bg-black-100 opacity-10"></div>
        <div className="mt-24 h-32 w-2/3 rounded-28 bg-black-100 opacity-10"></div>
        <div className="mt-56 h-40 w-full rounded-28 bg-black-100 opacity-10"></div>
      </div>
      <div className="hidden h-[464px] rounded-28 bg-white-100 p-32 md:col-span-6 md:grid lg:col-span-4 ">
        <motion.div
          className="m-auto mt-24 h-16 w-64 rounded-28 bg-black-100 opacity-10"
          initial={{ opacity: 0.1 }}
          animate={{ opacity: [0.1, 0.3, 0.1] }}
          transition={{ duration: 3, repeat: Infinity }}
        ></motion.div>
        <div className="mt-64 h-32 w-full rounded-28 bg-black-100 opacity-10"></div>
        <div className="mt-24 h-32 w-2/3 rounded-28 bg-black-100 opacity-10"></div>
        <div className="mt-56 h-40 w-full rounded-28 bg-black-100 opacity-10"></div>
      </div>
      <div className="col-span-full hidden h-[464px] rounded-28 bg-white-100 p-32 lg:col-span-4 lg:grid">
        <motion.div
          className="m-auto mt-24 h-16 w-64 rounded-28 bg-black-100 opacity-10"
          initial={{ opacity: 0.1 }}
          animate={{ opacity: [0.1, 0.3, 0.1] }}
          transition={{ duration: 3, repeat: Infinity }}
        ></motion.div>
        <div className="mt-64 h-32 w-full rounded-28 bg-black-100 opacity-10"></div>
        <div className="mt-24 h-32 w-2/3 rounded-28 bg-black-100 opacity-10"></div>
        <div className="mt-56 h-40 w-full rounded-28 bg-black-100 opacity-10"></div>
      </div>
    </div>
  );
};
export default CardCollectionLoading;
